<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增合同
      </el-button>
      <div class="former">
        <el-input
          v-model="form.Key"
          placeholder="合同编号、名称或签订人"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.ClientID"
          url="client"
          labelName="ClientName"
          placeholder="请选择客户"
          no-data-text="无客户"
          :urlParams="urlParams"
          q="ClientName:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-select
          v-model="form.VirtualStatus"
          clearable
          placeholder="状态"
          style="width: 100px"
        >
          <el-option label="启动" :value="1"></el-option>
          <el-option label="关闭" :value="2"></el-option>
        </el-select>
        &nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      tooltip-effect="light"
      style="margin-top: -15px"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column
        prop="ContractNumber"
        label="合同编号"
        width="190"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.ContractNumber }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.WithContract">
            {{ scope.row.WithContract.ContractNumber }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="合同名称" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.Name }}
          </div>
          <div>
            <el-tag>
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划销售台数:{{ scope.row.IpcSaleNum }} / 实际销售台数:{{ scope.row.IpcActSaleNum }}</div>
                </div>
                <i
                  class="fa fa-cart-shopping fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.IpcSaleNum }} / {{ scope.row.IpcActSaleNum }}
            </el-tag>
            <el-tag type="success">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划实施台数:{{ scope.row.IpcImplementationNum }} / 实际实施台数:{{ scope.row.IpcActImplementationNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.IpcImplementationNum }} / {{ scope.row.IpcActImplementationNum }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" align="center" width="50">
        <template slot-scope="scope">
          <div v-if="scope.row.ContractType">
            {{ scope.row.ContractType.Name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属客户" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.Client">{{ scope.row.Client.ClientName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属部门/交易买方" align="center" width="95">
        <template slot-scope="scope">
          <div v-if="scope.row.Department">
            {{ scope.row.Department.Name }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="业务组分类" align="center" width="95">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(code, index) in row.BusinessGroups"
            :key="index"
            style="margin-right: 5px; color: #00b3ca"
            >{{ getBusinessGroup(code) }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column label="日期信息" align="center">
        <el-table-column label="签订日期" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.CheckDay">
              {{ scope.row.CheckDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始/结束日期" align="center" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.ContractStartDay">
              {{ scope.row.ContractStartDay.substring(0, 10) }}
            </div>
            <div v-if="scope.row.ContractEndDay">
              {{ scope.row.ContractEndDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="关联平台" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.Platforms">
            <div v-for="platform in scope.row.Platforms" :key="platform.ID">
              <div>{{ platform.PlatformName }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="Amount"
        align="center"
        label="合同金额"
        width="90"
      />
      <!-- <el-table-column prop="ActualAmount" align="center" label="实收金额" width="90" /> -->
      <el-table-column
        prop="SignName"
        align="center"
        label="签订人"
        width="70"
      />
      <el-table-column width="70" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.VirtualStatus === 2" type="info">
            关闭
          </el-tag>
          <el-tag v-else type="success"> 启动 </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="180" align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="bindingPlatform(scope.row)"
            :disabled= "scope.row.VirtualStatus === 2"
            title="关联平台"
          >
            <i class="fas fa-link"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onSeeItem(scope.row)"
            :disabled= "scope.row.VirtualStatus === 2"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            :disabled= "scope.row.VirtualStatus === 2"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <binding
      v-model="item"
      :visible.sync="bindingVisible"
      @form:saved="getItemList"
    />
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :businessGroupList="businessGroupList"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";
import Binding from "../ipccontract/binding.vue";

export default {
  components: {
    ItemForm,
    Binding,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      businessGroupList: [],
      form: {
        Key: "",
        ClientID: "",
        VirtualStatus: "",
        Redirect: false, //记录是不是跳转过合同详情
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      bindingVisible: false,
      urlParams: { where: {} },
    };
  },
  mounted() {
    this.getBusinessGroupList();
    this.getItemList();
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("search")) {
      var serach = JSON.parse(sessionStorage.getItem("search"));
      if (serach.Redirect) {
        serach.Redirect = false;
        this.form = serach; //JSON.parse(sessionStorage.getItem("search"));
      }
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("search", JSON.stringify(this.form));
    });
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipc/contractVirtual", {
          params: {
            where: {
              "ContractNumber|Name|SignName:like": this.form.Key,
              ClientID: this.form.ClientID,
              IsVirtually: 1,
              VirtualStatus: this.form.VirtualStatus,
            },
            BusinessGroups: ["Ipc_BusinessGroup"],
            with: ["Client", "Platforms", "ContractType", "WithContract", "Department"],
            ...this.pager,
            order: ["-check_day"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //业务组分类
    getBusinessGroupList() {
      this.$axios
        .get("basic", {
          params: {
            type: "BusinessGroup",
          },
        })
        .then((response) => {
          this.businessGroupList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getBusinessGroup(code) {
      let name = "";
      this.businessGroupList.forEach((item) => {
        if (item.Type === code) {
          name = item.Name;
        }
      });
      return name;
    },
    getContractList() {
      this.$axios
        .get("ipc/product/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 编辑
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此合同吗？", "提示")
        .then(() => this.$axios.delete(`contract/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.item.BusinessGroups = ["Ipc_BusinessGroup"];
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {
        CheckDay: new Date(),
        ContractStartDay: new Date(),
        Amount: 0,
        ActualAmount: 0,
        IsVirtually: true,
        VirtualStatus: 1,
        IpcSaleNum: 0,
        IpcImplementationNum: 0,
        QATime: 1,
      };
    },
    onSeeItem(row) {
      this.form.Redirect = true; //标记跳转过合同详情
      this.$router.push({ name: "CpIpcContractDetail", params: { ID: row.ID } });
    },
    bindingPlatform(row) {
      this.item = row;
      this.bindingVisible = true;
    },
  },
};
</script>
